;(function ($) {


    // 1 minute timer (used on Tutorial page)

    // Open and close timer modal
    $('.js-collection-timer').click(function(e) {
        e.preventDefault()
        $('.collection__timer').addClass('opened')
    })
    $('.collection__timer-close').click(function() {
        $('.collection__timer').removeClass('opened')
    })

    var countdown = 60,
        numberEl = $('.collection__time'),
        countDownEl = $('.collection__countdown'),
        btn = $('.collection__timer-start'),
        timeout = null

    function resetTimer() {
        countdown = 60
        numberEl.text(countdown)
        clearInterval(timeout)
        countDownEl.removeClass('run')
        btn.text('Run timer again')
    }

    $('.collection__timer-start').click(function(e) {
        e.preventDefault()

        if(countDownEl.hasClass('run')) {
            resetTimer()
        } else {
            numberEl.text(countdown)
            countDownEl.addClass('run')
            btn.text('Reset timer')

            timeout = setInterval(function() {
                if (--countdown < 0) {
                    resetTimer()
                } else {
                    numberEl.text(countdown)
                }
            }, 1000)
        }
    })


})(jQuery);
